export default __webpack_public_path__ + "static/media/grama-esportiva2.af7773c7.jpg";